import Vue from 'vue'
import DateRangePicker from 'vue-daterange-picker-light'
//you need to import the CSS manually (in case you want to override it)
import 'vue-daterange-picker-light/dist/vue-daterange-picker-light.css'
// import your locale

Vue.component('date-range-picker', DateRangePicker)